<template>
  <ConfirmModal>
    <ConfirmPartner />
  </ConfirmModal>
</template>

<script>
import ConfirmModal from 'client/signup/ConfirmModal.vue';
import ConfirmPartner from 'client/signup/components/ConfirmPartner.vue';

export default {
  name: 'ConfirmPartnerContainer',

  components: {
    ConfirmModal,
    ConfirmPartner,
  },

};
</script>
